import React, { useEffect, useMemo } from "react"
import { isEmpty, chunk, get } from "lodash"

import { MenuPanel, Panel } from "components/organisms/panel"
import { Adr, ReitBase } from "components/organisms/panel/reit"
import { APIResponse } from "redux/apis/types"
import { useDispatch } from "react-redux"
import uuid from "uuid"
import { changeSymbol } from "redux/ducks/Chart"
import { PAGE_NUM, ROUTE_LIST } from "config/const"
import MiddleChart from "components/molecules/chart/middleChart"
import { InfoTable } from "components/molecules/table"
import { infoTableColumns } from "config/table_columns"
import { NewsList } from "components/organisms/panel/newsList"
import ClassNames from "classnames"
import { MainContainer } from "components/molecules/utils/mainContainer"
import { checkIsSp } from "utils/util"

type PropsType = {
  data: Array<APIResponse.Res>
  setData: Function
  totalCount: number
  currentContent: number
  changeContent: Function
  activeTab: number
  changeTab: Function
  detailsData: APIResponse.Res
  currentPage: number
  changePage: Function
  currentData: number
  changeData: Function
  rateData?: APIResponse.Res
  calcData?: number
  setCalcData?: Function
  numericSpinnerStatus?: number | string
  changeNumericSpinnerStates?: Function
  refreshFlag?: boolean
  setRefreshFlag?: Function
}

export const ETFTemplate: React.FC<PropsType> = props => {
  const isSp = checkIsSp()
  const dispatch = useDispatch()
  const canvasId = useMemo(() => {
    return uuid()
  }, [])

  useEffect(() => {
    if (isEmpty(props.data)) return
    dispatch(changeSymbol(canvasId, props.data[props.currentData]))
  }, [props.data])

  const menuTab = [
    {
      id: 0,
      name: "ETF",
      component: ReitBase,
      componentProps: {
        title: "ETF",
        data: props.data,
        currentPage: props.currentPage,
        totalCount: props.totalCount,
        changePage: props.changePage,
        changeData: props.changeData,
        activeTab: props.activeTab,
        changeTab: props.changeTab,
        canvasId: canvasId,
        setRefreshFlag: props.setRefreshFlag,
      },
    },
    {
      id: 1,
      name: "REIT",
      component: ReitBase,
      componentProps: {
        title: "REIT",
        data: props.data,
        currentPage: props.currentPage,
        totalCount: props.totalCount,
        changePage: props.changePage,
        changeData: props.changeData,
        activeTab: props.activeTab,
        changeTab: props.changeTab,
        canvasId: canvasId,
        setRefreshFlag: props.setRefreshFlag,
      },
    },
    {
      id: 2,
      name: "ADR",
      component: Adr,
      componentProps: {
        data: props.data,
        rateData: props.rateData,
        calcData: props.calcData,
        setCalcData: props.setCalcData,
        currentPage: props.currentPage,
        totalCount: props.totalCount,
        numericSpinnerStatus: props.numericSpinnerStatus,
        changeNumericSpinnerStates: props.changeNumericSpinnerStates,
        changePage: props.changePage,
        refreshFlag: props.refreshFlag,
      },
    },
  ]
  return (
    <MainContainer
      className={ClassNames({
        "symmetry-layout": props.currentContent !== 2,
        "domestic-container": props.currentContent === 2,
      })}
    >
      <div className="contents-block">
        <div className="contents-nest-block">
          <MenuPanel
            menu={menuTab}
            active={props.currentContent}
            changeMenu={(num: number) => {
              if (props.currentContent === num) return
              props.changeNumericSpinnerStates(props.calcData)
              props.changeContent(num)
              props.changeTab(0)
              props.changePage(0)
              props.changeData(0)
              props.setData([])
            }}
            className={ClassNames("panel-etf", { sp: isSp })}
            refresh={() => props.setRefreshFlag(true)}
          />
        </div>
      </div>
      {props.currentContent !== 2 && (
        <div className="contents-block ">
          <div className="contents-nest-block">
            {!isSp && (
              <Panel
                className="panel-etf-info panel-main-index"
                title=""
                nonePanelHeader={true}
                refresh={() => props.setRefreshFlag(true)}
              >
                <MiddleChart id={canvasId} />
                <InfoTable
                  list={infoTableColumns.indicative}
                  data={get(props.detailsData, "Symbol")}
                  className="table-striped table-index-detail"
                  wrapperCls="index-detail-table-row etf"
                />
              </Panel>
            )}
            <NewsList
              route={
                props.currentContent === 0
                  ? ROUTE_LIST.DOMESTIC_ETF
                  : ROUTE_LIST.DOMESTIC_REIT
              }
              effect={props.refreshFlag}
              setEffect={props.setRefreshFlag}
            />
          </div>
        </div>
      )}
    </MainContainer>
  )
}
